// src/services/api.js
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const fetchProducts = () => axios.get(`${API_BASE_URL}/products`);

export const createOrder = (orderData) => {
    console.log(`appel fonction createOrder avec orderData ${JSON.stringify(orderData)}`)
    return axios.post(`${API_BASE_URL}/orders`, orderData);
};

export const getMyOrders = () => {
    return axios.get(`${API_BASE_URL}/orders/my-orders`);
};

